module.exports = __webpack_public_path__ + "static/media/1006.2f4ca5e5.jpg";